import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Constant } from '@app/models/enums/constant.enum';
import { ThemeList, ThemeService } from '@core/services/theme';
import { cleanAppStorage } from '@core/utils';
import { ROUTER_UTILS } from '@core/utils/router.utils';
import { AuthService } from '@services/auth.service';
import { SystemService } from '@services/system.service';
import { format } from 'date-fns';
import { lastValueFrom, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

declare const particlesJS: any;

import { CommonModule } from '@angular/common';
import { WavesJsComponent } from '@app/components/ui/layout/waves-js/waves-js.component';
import { SidebarComponent } from '@app/components/ui/sidebar/sidebar.component';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
@Component({
  standalone: true,
  selector: 'app-layout',

  imports: [CommonModule, WavesJsComponent, SidebarComponent, NzLayoutModule],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
})
export class LayoutComponent implements OnInit {
  private readonly smallScreenQuery = '(max-width: 768px), (pointer: coarse) and (max-width: 1024px)';

  isShowNav = false;
  resetNav = false;

  isCollapsed = true;

  path = ROUTER_UTILS;

  constructor(private router: Router, private authService: AuthService, private themeService: ThemeService, private systemService: SystemService) {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
      if (e.url.indexOf(this.path.business.smb) !== -1) {
        this.isShowNav = false;
        // smb 使用light主题
        this.themeService.setTheme(ThemeList.NIQLight);
      } else {
        this.isShowNav = true;

        if (e.url.indexOf(this.path.business.ecommerce) === -1) {
          // 不是“我的模板”页面, 则重置导航（模块为订阅模块的并集）
          this.resetNav = false;
          setTimeout(() => {
            this.resetNav = true;
          });
        }
        // 需求：默认全收起来
        this.isCollapsed = true;
      }
    });
    let _config: 'dark' | 'light';
    this.themeService.currentTheme$.subscribe(theme => {
      const config = theme === ThemeList.NIQDark ? 'dark' : 'light';
      if (config !== _config) {
        _config = config;
        if (this.isSmallScreen()) {
          this.clearParticles();
          return;
        }
        particlesJS.load('particles-js', `assets/particles/particles-${config}.json`, function () {
          console.log('callback - particles.js config loaded');
        });
      }
    });
  }

  showBlockTime = '';
  timerHandle: any = null;

  isLoggedIn$!: Observable<boolean>;
  ngOnInit(): void {
    // console.info(getWeekendsForCurrYear());
    this.isLoggedIn$ = this.authService.isLoggedInSubject;
    this.checkBlockUI();
    this.clearTimeInterval();
    this.timerHandle = setInterval(() => {
      this.checkBlockUI();
    }, 60000);
  }

  clearTimeInterval() {
    if (this.timerHandle) {
      clearInterval(this.timerHandle);
      this.timerHandle = null;
    }
  }

  isValidDateString(str: string) {
    const t = Date.parse(str);
    return !isNaN(t); // true → valid date; false → invalid date
  }

  async checkBlockUI() {
    const res = await lastValueFrom(this.systemService.getSysFeatures());
    const blockDuration = res['IS_BLOCK_UI'];
    const blockTime: string[] = blockDuration?.split(',');
    this.showBlockTime = '';
    if (blockTime && blockTime.length === 2 && this.isValidDateString(blockTime[0]) && this.isValidDateString(blockTime[1])) {
      const startBlockTime = new Date(blockTime[0]);
      const endBlockTime = new Date(blockTime[1]);
      const now = new Date();
      if (now.getTime() > startBlockTime.getTime() && now.getTime() < endBlockTime.getTime()) {
        this.showBlockTime = format(startBlockTime, Constant.FORMAT_HOURS) + ' - ' + format(endBlockTime, Constant.FORMAT_HOURS);
      }
    }

    // IS_BLOCK_UI  清空缓存  跳转到登录页面
    if (this.showBlockTime) {
      cleanAppStorage();
      const { root, login } = ROUTER_UTILS.config.auth;
      this.router.navigate(['/', root, login]);
    }
  }

  private isSmallScreen(): boolean {
    return typeof window !== 'undefined' && (window.matchMedia?.(this.smallScreenQuery).matches || window.innerWidth <= 768);
  }

  private clearParticles(): void {
    const particles = document.getElementById('particles-js');
    const canvases = particles?.getElementsByClassName('particles-js-canvas-el');

    while (canvases?.length) {
      particles?.removeChild(canvases[0]);
    }
  }
}
